import { lazy } from 'react';

const DCRViewer = lazy(() => import('../pages/DCRViewer'));
const DCRViewerV2 = lazy(() => import('../pages/DCRViewer/DCRViewerV2'));

const dcrViewerRoute = {
  public: [],
  auth: [
    {
      name: 'dcr-listing',
      path: '/dcr-listing',
      component: DCRViewer,
      permissions: [
        'KASM',
        'KASOM',
        'KASROM',
        'KASH',
        'SAM',
        'RSM',
        'NSM-SPARTAN',
        'admin',
        'COO',
        'EXECUTIVE',
        'SFE',
      ],
    },
    {
      name: 'dcr-listing-id',
      path: '/dcr/view/:id',
      component: DCRViewerV2,
    },
  ],
};

export default dcrViewerRoute;
